import styled from 'styled-components';
import { animated } from '@react-spring/web';
import { StyledDataPointProps } from './types';

/**
 * Component style.
 */
export const StyledDataPoint = styled(animated.g)<StyledDataPointProps>``;
